import { useEffect } from 'react';
import { $t } from 'hooks/i18n';
import { CanView } from 'components/Can';
import { TabView, TabPanel } from 'primereact/tabview';
import { Title } from 'components/Title';
import AgentmasterListPage from 'pages/agentmaster/List';
import LoangroupListPage from 'pages/loangroup/List';
import useApp from 'hooks/useApp';

const MasterDetailPages = (props) => {
		const app = useApp();
	const { masterRecord, scrollIntoView = true } = props;
	const activeTab = 0;
	function scrollToDetailPage() {
		if (scrollIntoView) {
			const pageElement = document.getElementById('master-detailpage');
			if(pageElement){
				pageElement.scrollIntoView({behavior:'smooth', block:'start'});
			}
		}
	}
	// pass form data from master to detail
	function setDetailPageFormData(){
		const record = masterRecord;
		// set  form data
		const loangroupFormData = { sales_empcode:record?.empcode }
		app.setPageFormData('loangroup', loangroupFormData);
		// set  form data
		const agentmasterFormData = { empcode:record?.empcode }
		app.setPageFormData('agentmaster', agentmasterFormData);
	}
	// pass form data from master to detail
	useEffect(() => {
		scrollToDetailPage();
		setDetailPageFormData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [masterRecord]);
	if(masterRecord){
		return (
<div id="master-detailpage">
    <TabView value={activeTab}>
        <TabPanel header={<Title title={$t('empmasterLoangroup')}  headerClass="p-0" titleClass="text-lg font-bold"  iconClass="pi pi-th-large" avatarSize="small"    separator={false} />}>
            <CanView pagePath="loangroup">
                <div className="reset-grid">
                    <LoangroupListPage isSubPage  fieldName="sales_empcode" fieldValue={masterRecord.empcode} showBreadcrumbs={false} showHeader={false} showFooter={true}>
                    </LoangroupListPage>
                </div>
            </CanView>
        </TabPanel>
        <TabPanel header={<Title title={$t('empmasterAgentmaster')}  headerClass="p-0" titleClass="text-lg font-bold"  iconClass="pi pi-th-large" avatarSize="small"    separator={false} />}>
            <CanView pagePath="agentmaster">
                <div className="reset-grid">
                    <AgentmasterListPage isSubPage  fieldName="empcode" fieldValue={masterRecord.empcode} showBreadcrumbs={false} showHeader={false} showFooter={true}>
                        </AgentmasterListPage>
                    </div>
                </CanView>
            </TabPanel>
        </TabView>
    </div>
		);
	}
}
export default MasterDetailPages;
